<template>
    <section class="UniversitySearchResults">
        <h2 class="Title">University search is not available yet.</h2>
        {{searchStore.pageData}}
    </section>
</template>

<script setup lang="ts">
import { useSearchStore } from "@stores/useSearchStore";

const searchStore = useSearchStore();
</script>

<style scoped lang="scss">
    .UniversitySearchResults {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        @include PaddingAreas(2, 0);
    }

    .Title {
        color: $Grey-900;
        @include TextStyle(HeadingSmall);

        @include Breakpoint(Large, ExtraLarge) {
            @include TextStyle(HeadingMedium);
        }
    }
</style>